<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card" style="width: calc(70% - 2em)">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("create module") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="tabs is-toggle is-fullwidth" ref="tabs">
          <ul>
            <li class="is-active" data-tab="general" @click="change_active_tab">
              <a>
                <i class="info icon" aria-hidden="true"></i>
                <span>{{ $t("general") }}</span>
              </a>
            </li>
            <li data-tab="resources" @click="change_active_tab">
              <a>
                <i class="key icon" aria-hidden="true"></i>
                <span>{{ $t("resources") }}</span>
              </a>
            </li>
            <li data-tab="routes" @click="change_active_tab">
              <a>
                <i class="route icon" aria-hidden="true"></i>
                <span>{{ $t("routes") }}</span>
              </a>
            </li>
            <li data-tab="dictionary" @click="change_active_tab">
              <a>
                <i class="language icon" aria-hidden="true"></i>
                <span>{{ $t("dictionary") }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="container is-fluid" ref="contents">
          <div class="" data-tab="general">
            <form>
              <div class="field is-grouped">
                <div class="field">
                  <label class="label">{{ $t("code name") }}</label>
                  <div class="control">
                    <input class="input" type="text" v-model="meta.code_name" />
                  </div>
                </div>
                <div class="field">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    id="chk_show_in_home_create"
                    v-model="meta.show_in_home"
                  />
                  <label for="chk_show_in_home_create">{{
                    $t("show in home screen")
                  }}</label>
                </div>
                <div class="field">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    id="chk_is_configurable_create"
                    v-model="meta.is_configurable"
                  />
                  <label for="chk_is_configurable_create">{{
                    $t("is configurable")
                  }}</label>
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("icon image url") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.home_icon" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("title in home") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.home_title" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $t("home url") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.home_url" />
                </div>
              </div>
            </form>
            <article class="message is-info">
              <div class="message-header">
                <p>{{ $t("some guidance info") }}</p>
              </div>
              <div class="message-body">
                <ul>
                  <li>
                    <b>{{ $t("code name") }}</b>
                    {{
                      $t(
                        "should by the name of the module directory, lowercased and without spaces but underscore"
                      )
                    }}
                  </li>
                  <li>
                    <b>{{ $t("icon image url") }}</b>
                    {{
                      $t(
                        "the URL of the image that will be used for this module"
                      )
                    }}
                  </li>
                  <li>
                    <b>{{ $t("title in home") }}</b>
                    {{
                      $t(
                        "is the title that will be rendered in home screen for the module"
                      )
                    }}
                  </li>
                  <li>
                    <b>{{ $t("home url") }}</b>
                    {{
                      $t(
                        "is the path the user will be redirect on clicking the module in home screen"
                      )
                    }}
                  </li>
                </ul>
              </div>
            </article>
          </div>
          <div class="is-hidden" data-tab="resources">
            <div class="container">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="add_public_resource"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
              <h5 class="title is-5">{{ $t("public resources") }}</h5>
              <table
                class="table is-bordered is-fullwidth"
                v-if="meta && meta.resources && meta.resources.public"
              >
                <thead>
                  <tr>
                    <th>{{ $t("path") }}</th>
                    <th>{{ $t("name") }}</th>
                    <th>{{ $t("method") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rsrc, ridx) in meta.resources.public" :key="ridx">
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.resources.public[ridx].path"
                        placeholder="^/path_to_resource$"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.resources.public[ridx].name"
                      />
                    </td>
                    <td>
                      <div class="select">
                        <select v-model="meta.resources.public[ridx].method">
                          <option value="GET">GET</option>
                          <option value="POST">POST</option>
                          <option value="PUT">PUT</option>
                          <option value="DELETE">DELETE</option>
                          <option value="SOCKET">SOCKET</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <button
                        class="button is-secondary has-text-danger is-rounded"
                        @click="meta.resources.public.splice(ridx, 1)"
                        :data-tooltip="$t('delete')"
                      >
                        <span class="icon">
                          <i class="fa fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="container mt-6">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="add_private_resource"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
              <h5 class="title is-5">{{ $t("private resources") }}</h5>
              <table
                class="table is-bordered is-fullwidth"
                v-if="meta && meta.resources && meta.resources.private"
              >
                <thead>
                  <tr>
                    <th>{{ $t("path") }}</th>
                    <th>{{ $t("name") }}</th>
                    <th>{{ $t("method") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(rsrc, ridx) in meta.resources.private"
                    :key="ridx"
                  >
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.resources.private[ridx].path"
                        placeholder="^/path_to_resource$"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.resources.private[ridx].name"
                      />
                    </td>
                    <td>
                      <div class="select">
                        <select
                          class="select"
                          v-model="meta.resources.private[ridx].method"
                        >
                          <option value="GET">GET</option>
                          <option value="POST">POST</option>
                          <option value="PUT">PUT</option>
                          <option value="DELETE">DELETE</option>
                          <option value="SOCKET">SOCKET</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <button
                        class="button is-secondary has-text-danger is-rounded"
                        @click="meta.resources.private.splice(ridx, 1)"
                        :data-tooltip="$t('delete')"
                      >
                        <span class="icon">
                          <i class="fa fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <pre>{{ meta.resources }}</pre> -->
          </div>
          <div class="is-hidden" data-tab="routes">
            <div class="container">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="add_client_route"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
              <h5 class="title is-5">{{ $t("client routes") }}</h5>
              <table
                class="table is-bordered is-fullwidth"
                v-if="meta && meta.routes && meta.routes.client"
              >
                <thead>
                  <tr>
                    <th>{{ $t("path") }}</th>
                    <th>{{ $t("name") }}</th>
                    <th>{{ $t("component") }}</th>
                    <th>{{ $t("page title") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rsrc, ridx) in meta.routes.client" :key="ridx">
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.client[ridx].path"
                        placeholder="/path_to_route"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.client[ridx].name"
                        placeholder="name_of_route"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.client[ridx].component"
                        placeholder="Component.vue"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.client[ridx].meta.title"
                      />
                    </td>
                    <td>
                      <button
                        class="button is-secondary has-text-danger is-rounded"
                        @click="meta.routes.client.splice(ridx, 1)"
                        :data-tooltip="$t('delete')"
                      >
                        <span class="icon">
                          <i class="fa fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="container mt-6">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="add_api_route"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
              <h5 class="title is-5">{{ $t("api routes") }}</h5>
              <table
                class="table is-bordered is-fullwidth"
                v-if="meta && meta.routes && meta.routes.api"
              >
                <thead>
                  <tr>
                    <th>{{ $t("file path") }}</th>
                    <th>{{ $t("route") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(rsrc, ridx) in meta.routes.api" :key="ridx">
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.api[ridx].file_path"
                        placeholder="file_with_route.js"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="meta.routes.api[ridx].route"
                        placeholder="/route_name"
                      />
                    </td>
                    <td>
                      <button
                        class="button is-secondary has-text-danger is-rounded"
                        @click="meta.routes.api.splice(ridx, 1)"
                        :data-tooltip="$t('delete')"
                      >
                        <span class="icon">
                          <i class="fa fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <pre>{{ meta.routes }}</pre> -->
          </div>
          <div class="is-hidden" data-tab="dictionary">
            <div v-for="(dict, didx) in dictionary" :key="didx" class="mt-6">
              <p class="buttons is-pulled-right">
                <button
                  class="button is-secondary is-rounded"
                  @click="add_token(dict)"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>{{ $t("add") }}</span>
                </button>
              </p>
              <h5 class="title is-5">{{ dict.lang }}</h5>
              <table class="table is-bordered is-fullwidth">
                <thead>
                  <tr>
                    <th>{{ $t("token") }}</th>
                    <th>{{ $t("value") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(entry, eidx) in dict.dict" :key="eidx">
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="dictionary[didx].dict[eidx].token"
                        :placeholder="$t('token_to_translate')"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="input"
                        v-model="dictionary[didx].dict[eidx].value"
                        :placeholder="$t('translation goes here')"
                      />
                    </td>
                    <td>
                      <button
                        class="button is-secondary has-text-danger is-rounded"
                        @click="dictionary[didx].dict.splice(eidx, 1)"
                        :data-tooltip="$t('delete')"
                      >
                        <span class="icon">
                          <i class="fa fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-rounded is-primary"
            :disabled="!is_form_valid"
            @click="save"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded is-danger" @click="close_modal">
            <span class="icon"><i class="fa fa-close"></i></span>
            <span>{{ $t("close") }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { generate_error_message_text, put, get } from "@/utils";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";

export default {
  name: "CreateModuleModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      meta: {},
      code_name: "",
      dictionary: [],
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      let v = this;
      if (v.meta.show_in_home) {
        return (
          v.meta &&
          v.meta.code_name &&
          v.meta.home_icon &&
          v.meta.home_title &&
          v.meta.home_url
        );
      } else {
        return v.meta && v.meta.code_name;
      }
    },
  },
  methods: {
    set_initial_state() {
      this.meta = {
        code_name: "",
        // code_name: "test_module",
        is_configurable: true,
        show_in_home: true,
        home_icon: "",
        // home_icon: "https://cdn-icons-png.flaticon.com/512/5332/5332306.png",
        home_title: "",
        // home_title: "test module",
        home_url: "",
        // home_url: "/test_module",
        resources: {
          public: [
            // {
            //   path: "^/order_taking/order$",
            //   method: "PUT",
            //   name: "put an order",
            // },
          ],
          private: [
            // {
            //   path: "^/order_taking/order/datatables.*$",
            //   method: "GET",
            //   name: "get list of orders",
            // },
          ],
        },
        routes: {
          client: [
            {
              path: "/module_name",
              name: "module_name_index",
              component: "Index.vue",
              meta: {
                title: "Module_name index",
              },
            },
          ],
          api: [
            // { file_path: "router_controller.js", route: "/module_name" },
          ],
        },
      };
      this.code_name = "";
      this.dictionary = [
        { lang: "es", dict: [] },
        { lang: "en", dict: [] },
      ];
      this.error = "";
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    clone_modal(mdle) {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      if (mdle && mdle.code_name) {
        get("/module/definition", { code_name: mdle.code_name })
          .then((response) => {
            delete response.code_name;
            v.meta = response;

            // Transform dictionary
            let languages = Object.keys(response.dictionary).map((lang) => {
              let dict = Object.keys(response.dictionary[lang]).map((k) => {
                return { token: k, value: response.dictionary[lang][k] };
              });
              return { lang: lang, dict: dict };
            });
            v.dictionary = languages;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    show_modal(code_name) {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      v.code_name = code_name;
    },
    change_active_tab($event) {
      let v = this;
      let target = $event.target;
      let active_tab = "";
      if (target) active_tab = window.jQuery(target).closest("li").data("tab");
      if (active_tab) {
        /** Headers */
        window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
        window
          .jQuery(v.$refs.tabs)
          .find(`li[data-tab=${active_tab}]`)
          .addClass("is-active");

        /** Content */
        window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
        // .attr("display", "none");
        window
          .jQuery(v.$refs.contents)
          .find(`div[data-tab=${active_tab}]`)
          .removeClass("is-hidden");
      }
    },
    add_public_resource() {
      let v = this;
      v.meta.resources.public.push({
        path: "",
        method: "",
        name: "",
      });
    },
    add_private_resource() {
      let v = this;
      v.meta.resources.private.push({
        path: "",
        method: "",
        name: "",
      });
    },
    add_client_route() {
      let v = this;
      v.meta.routes.client.push({
        path: "",
        component: "",
        meta: {
          title: "",
        },
      });
    },
    add_api_route() {
      let v = this;
      v.meta.routes.api.push({
        file_path: "",
        route: "",
      });
    },
    save() {
      let v = this;

      let data = { ...v.meta };
      data.dictionary = v.dictionary.reduce((acc, lang) => {
        acc[lang.lang] = lang.dict.reduce((acc, entry) => {
          acc[entry.token] = entry.value;
          return acc;
        }, {});
        return acc;
      }, {});

      put("/module", data)
        .then(() => {
          v.close_modal();
          v.$emit("success");
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    add_token(dict) {
      dict.dict.push({ token: "", value: "" });
    },
  },
  mounted() {},
};
</script>
<style></style>
